// Lib
import * as Immutable from 'immutable';
import { includes } from 'lodash';

// Constants
import * as SELECTION_ACTION_TYPES from '../../../common/elements/selectionConstants';
import { START_OPERATION, END_OPERATION } from '../../utils/undoRedo/undoRedoConstants';

const initialState = Immutable.fromJS({
    ids: [],
    keepSelection: false,
    meta: Immutable.fromJS({}),
});

export default function selection(state = initialState, action) {
    switch (action.type) {
        case SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
            return state.update('ids', (ids) => ids.concat(action.ids));
        case SELECTION_ACTION_TYPES.ELEMENTS_DESELECTED:
            return state
                .update('ids', (ids) => ids.filterNot((id) => includes(action.ids, id)))
                .set('meta', Immutable.fromJS({}));
        case SELECTION_ACTION_TYPES.ELEMENTS_DESELECT_ALL:
            return state.get('keepSelection') ? state : initialState;
        case START_OPERATION:
            return state.set('keepSelection', true);
        case END_OPERATION:
            return state.set('keepSelection', false);
        case SELECTION_ACTION_TYPES.TABLE_ELEMENT_CELL_SELECTIONS_UPDATE: {
            const isElementSingleSelected = state.get('ids').size === 1 && state.get('ids').first() === action.id;
            if (!isElementSingleSelected) return state;

            return state.set('meta', Immutable.fromJS({ currentCellSelections: action.cellSelections }));
        }
        default:
            return state;
    }
}
